module.exports = __webpack_public_path__ + "assets/img/Kaplan-Professional-Pillar-Page-Resource-w720.86051561.jpg";